import React from 'react';
import { Button, ButtonGroup, Stack, ProgressBar, Toast, ToastContainer, Tooltip, OverlayTrigger  } from 'react-bootstrap';
import { downloadFile, downloadFiles } from './../../apis/fileApi';

import { usePermissionContext } from '../../auth/AuthContext';
import { useDownloadFileProgress } from '../../context/DownloadFileContext';
import { Archive, Download } from 'react-bootstrap-icons';

const DeleteFile  = ({rowProps, disable}) =>
{   
    const [downloadProgress, setDownloadProgress] = React.useState({show: false, progress: 0});
    const { hasRole } = usePermissionContext();
    const fileData = rowProps.data;
    const handleDeleteFile = async () => 
    {
    }

    return  <Button name="archive" className="disabled-button button-table"  label="archive" disabled><Archive/></Button>
}

export const FileActions = (rowProps) => 
{
    const { hasRole } = usePermissionContext();
    const { startDownload, updateProgress, updateErrorDownloads } = useDownloadFileProgress();

    const handleDownloadFile = async () => {
        const {downloadId, downloadSignal} = startDownload(rowProps.data.id, rowProps.data.fileName);
    
        const response = await downloadFile(rowProps.data, updateProgress, downloadId, downloadSignal);
        if (response.status === "error" || response.status === "warning") {
            rowProps.setErrorMessage({ show: true, message: response.message, status: response.status });
            updateErrorDownloads(response.download_id);
        }
    }

    return(<>
        <ButtonGroup>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Download File</Tooltip>}>
                <Button  disabled={false} name="download" className="jobAction button-table" label="download" onClick={handleDownloadFile} ><Download/></Button>
            </OverlayTrigger>
        </ButtonGroup>
        </>
    )
}

export const BatchFileActions = ({gridRef, setErrorMessage}) =>{

    const { hasRole } = usePermissionContext();
    const { batchStartDownload, updateProgress, updateErrorDownloads } = useDownloadFileProgress();
    
    const handleBatchDownload = async () => {
        const selectedRows = gridRef.current.api.getSelectedRows(); 
        const batchDownloadInfo = batchStartDownload(selectedRows);
        
        const responses = await downloadFiles(batchDownloadInfo, updateProgress);
        const errors = responses.filter((response) => response.status === "error");
        if (errors.length > 0) {
            const errorIds = errors.map((error) => 
                {
                    updateErrorDownloads(error.download_id);
                    return error.id
                }).join("\n");
            setErrorMessage({ show: true, message: `Some files failed to download: ${errorIds}` });
        }
    }

    return(
        <Stack direction="horizontal" gap={1} className='action-stack'>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Download Files</Tooltip>}>
                <Button disabled={!hasRole('Admin')}  name="download" className="jobAction  button-table" label="download" onClick={handleBatchDownload}><Download/></Button>
            </OverlayTrigger>
        </Stack>
    )
}